import React from "react";
import './v.css';
import 'firebase/firestore';
import 'firebase/database'; // If using Firebase database
import db from "../firebase";
import { Link } from 'react-router-dom';

let code:any;

const handleKeyDownCODE = (event: { key: string; }) => {
  if (event.key === 'Enter') {
    //console.log("ACUMMMMMM");
    code = (document.getElementById("paste-input") as HTMLInputElement).value;
    document.getElementById('brick')?.remove();
    computePage(code);
  }
}

getStats();

async function paste() {
  const text = await navigator.clipboard.readText();
  (document.getElementById('paste-input') as HTMLInputElement)!.value = text;
  code = (document.getElementById("paste-input") as HTMLInputElement).value;
  document.getElementById('brick')?.remove();
  computePage(code);
}



let ephochTimeFromToday = Math.floor(new Date().getTime()/1000.0);
//console.log("acum");
//console.log(ephochTimeFromToday);
//let ephochTimeFromYesterday = ephochTimeFromToday - 86400;
//console.log("epochh ");
//console.log(ephochTimeFromYesterday);

//check if there are polls with the time variable
//greater than the actual time

db.collection("questions").onSnapshot((snapshot) => {
  // eslint-disable-next-line array-callback-return
  snapshot.docs.map((doc) => {
    //console.log(doc.data().time);
    if(ephochTimeFromToday > doc.data().time + 86400) {
     // console.log(doc.data().time + " a depasit " + doc.id);
      db.collection("questions").doc(doc.id).delete();
    }
    else {
      //console.log(doc.data().time + " NU a depasit");
    }
  })
})

function getStats() {
  db.collection("total").doc("total-number")
  .get()
  .then(function(doc) {
    if (doc.exists) {
      //console.log(doc.data()!.nr);
      (document.getElementById('stats') as HTMLDivElement).textContent = doc.data()!.nr + " ideas counted already. ❤️";
    } else {
      // doc.data() will be undefined in this case
      //console.log("No such document!");
    }
    }).catch(function(error) {
        //console.log("Error getting document:", error);
    });
}
    
    //const lastSegmentOfUrl = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
//console.log(code);

let maxLikes = 0;
let maxLikesPos = 0;

let auxQuestion: any;
let variantArray: Array<string>;
let likesArray: Array<any>;
variantArray = [];
likesArray = [];

function areThereAnyUpdates() {
  //console.log("sunt update uri ?");
  db.collection("questions").doc(code).get().then(function(doc){
    if (doc.exists) {
      //console.log(doc.data());
      let vr = doc.data()!.variants.variant.length;
      //console.log(vr);
      let auxvr = variantArray.length
      //console.log(auxvr);

      let updates = document.getElementById('the-footer-btn') as HTMLDivElement;
      if(auxvr !== vr) {
        updates.textContent = "New variants!";
        updates.style.backgroundColor = "gold";
        updates.style.color = 'black';
      }
      else {
        updates.textContent = "Refresh";
      }
    }
    
  })
  timer();
}

function timer() {
  setTimeout(() => {
    //console.log("a trecut inca 1 minut");
    areThereAnyUpdates();
  }, 10000);
}

setTimeout(() => {
  //console.log("a trecut primul minut");
  areThereAnyUpdates();
}, 3000);

function computePage(lastSegmentOfUrl:any) {
  //we check the time left
  db.collection("questions").doc(lastSegmentOfUrl)
  .get()
  .then(function(doc) {
    if (doc.exists) {
      let actualEphochTime = Math.floor(new Date().getTime()/1000.0);
      let prevEpochTime = doc.data()!.time;
      let timePassed = (actualEphochTime-prevEpochTime)/3600;
      //console.log("time passed " + timePassed);
      let intTimePassed = Math.trunc( timePassed );
      //console.log(24 - intTimePassed + " hours left");

      let timeDiv = document.createElement('div') as HTMLDivElement;
      timeDiv.id = 'time-id';
      timeDiv.textContent = (24 - intTimePassed) + " hours left";

      let theMain = document.getElementById('root') as HTMLDivElement;
      theMain.appendChild(timeDiv);

      let footer = document.createElement('div') as HTMLDivElement;
      footer.id = 'the-footer-id';
      let footerBtn = document.createElement('div') as HTMLDivElement;
      footerBtn.textContent = "Refresh";
      footerBtn.id = 'the-footer-btn';
      footerBtn.onclick = function() {
        document.getElementById("mid-id")?.remove();
        document.getElementById("header")?.remove();
        document.getElementById("spacer")?.remove();
        document.getElementById("the-footer-btn")!.remove();
        document.getElementById("the-footer-id")!.remove();
        document.getElementById("time-id")!.remove();
        computePage(lastSegmentOfUrl);
      }

      footer.appendChild(footerBtn);
      theMain.appendChild(footer);
    } else {
      // doc.data() will be undefined in this case
      //console.log("No such document!");
    }
    }).catch(function(error) {
      //console.log("Error getting document:", error);
  });

  db.collection("questions").doc(lastSegmentOfUrl)
  .get()
  .then(function(doc) {
    if (doc.exists) {
      //"Document data:", doc.data());
      //console.log("Document data:", doc.data()!.question + " " + doc.data()!.variants.likes);

      //save all data
      let _question = doc.data()!.question;
      let _variants: Array<string>;
      _variants = doc.data()!.variants.variant;
      let _likes = doc.data()!.variants.likes;

      
      let len:any = _variants.length;

      auxQuestion = _question;
      //finding the most liked
      for(let i = 0; i < len; i++) {
        variantArray[i] = _variants[i];
        likesArray[i] = _likes[i];

        if(_likes[i] > maxLikes) {
          maxLikes = _likes[i];
          maxLikesPos = i;
        }
      }

      let root = (document.getElementById("root") as HTMLInputElement);

      let spacer = document.createElement("div") as HTMLDivElement;
      spacer.id = "spacer";
      
      let header = document.createElement('div') as HTMLDivElement;
      header.id = "header";
      
      
      let mid = document.createElement("div") as HTMLDivElement;
      mid.id = "mid-id";
      
      let newVariant = document.createElement("input") as HTMLInputElement;
      newVariant.inputMode = "text";
      newVariant.placeholder = "Enter anonymous idea";
      newVariant.id = "newVariant";
      newVariant.onkeydown = handleKeyDown;
      newVariant.autocomplete = "off";
      newVariant.spellcheck = false;

      let theHead = document.createElement("div") as HTMLDivElement;
      theHead.id = 'the-head';
      
      let ques = document.createElement('div') as HTMLDivElement;
      ques.id = "question-id";
      ques.textContent = _question;

      let holder = document.createElement('div') as HTMLDivElement;
      holder.id = 'holder';

      let enterBtn = document.createElement('div') as HTMLDivElement;
      enterBtn.id = 'btnn';
      enterBtn.onclick = function() {addVariant();(document.getElementById("newVariant") as HTMLInputElement).value = "";}
      enterBtn.textContent = "Enter";

      holder.appendChild(newVariant);
      holder.appendChild(enterBtn);

      
      for(let i = 0; i < len; i++) {
        let variantBlock = document.createElement('div') as HTMLDivElement;
        variantBlock.id = "variant-block";

        if(i === maxLikesPos) {
          variantBlock.style.borderStyle = "solid";
          variantBlock.style.borderColor = "yellowgreen";
          variantBlock.style.borderWidth = "5px";
        }
        
        variantBlock.textContent = _variants[i];

        let likeBlock = document.createElement('div') as HTMLDivElement;
        likeBlock.id = "like-block";
        likeBlock.textContent = _likes[i] + " 👍";
        variantBlock.appendChild(likeBlock);

        //add function to each variant
        variantBlock.onclick = function() {
          let prompt = document.createElement('div') as HTMLDivElement;
          prompt.id = 'prompt';
          prompt.textContent = "Like 🡪 " + _variants[i] + " ?";

          //console.log("acummmmmm");
          let v: Array<string>;
          v = [];
          let l: Array<number>;
          l = [];
          db.collection("questions").doc(lastSegmentOfUrl).get().then(function(doc){
            //console.log(doc.data());
            v = doc.data()!.variants.variant;
            //console.log(v);
            l = doc.data()!.variants.likes;
            db.collection("questions").doc(lastSegmentOfUrl).update({
              question: _question,
              variants:{variant: v, likes: l}
            })
          })
          
          let btnNo = document.createElement('button');
          btnNo.textContent = "No";
          btnNo.id = "btnNo";

          let btnYes = document.createElement('button');
          btnYes.textContent = "Yes";
          btnYes.id = "btnNo";

          //voted
          btnYes.onclick = function() {
            //console.log("VOTED 1");
            document.getElementById('prompt')!.remove();
            _likes[i]++;
            variantBlock.textContent = _variants[i] + " voted by you.";
            l[i]++;

            variantBlock.style.backgroundColor = "blue";

            

            db.collection("questions").doc(lastSegmentOfUrl).update({
              question: _question,
              variants:{variant: v, likes: l}
            })

            //UPDATING
            document.getElementById("mid-id")?.remove();
        document.getElementById("header")?.remove();
        document.getElementById("spacer")?.remove();
        document.getElementById("the-footer-btn")!.remove();
        document.getElementById("the-footer-id")!.remove();
        document.getElementById("time-id")!.remove();

            window.setTimeout(function () {
              computePage(lastSegmentOfUrl);
            }, 500);

          }

          btnNo.onclick = function() {
            document.getElementById('prompt')!.remove();
          }

          prompt.appendChild(btnYes);
          prompt.appendChild(btnNo);
          root.appendChild(prompt);
        }

        mid.appendChild(variantBlock);
      }
      
      let main = document.getElementById('main') as HTMLDivElement;
      header.appendChild(ques);
      header.appendChild(holder);
      theHead.appendChild(main);
      theHead.appendChild(header);
      root.appendChild(theHead);
      root.appendChild(spacer);
      root.appendChild(mid);


    } else {
      // doc.data() will be undefined in this case
      //console.log("No such document!");
      let msg = document.createElement('div') as HTMLDivElement;
      let rot = document.getElementById('main') as HTMLDivElement;
      msg.id = "msg";
      msg.textContent = ":( Invalid code. OR The link expired. But these are for you ❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️";

      rot.appendChild(msg);
    }
}).catch(function(error) {
    //console.log("Error getting document:", error);
});
}


const addVariant = () => {
  updateTotalNumber();
  let i = variantArray.length;
  variantArray[i] = (document.getElementById("newVariant") as HTMLInputElement).value;
  likesArray[i] = 0;

  //console.log(variantArray);
  //console.log(likesArray);

  db.collection("questions").doc(code)
  .get()
  .then(function(doc) {
    if (doc.exists) {
      db.collection("questions").doc(code).update({
        question: auxQuestion,
        variants:{variant: variantArray, likes: likesArray}
      })
    } else {
      // doc.data() will be undefined in this case
      //console.log("No such document!");
    }
    }).catch(function(error) {
        //console.log("Error getting document:", error);
  });


  let variantBlock = document.createElement('div') as HTMLDivElement;
  variantBlock.id = "variant-block";
  variantBlock.textContent = variantArray[i];

  let likeBlock = document.createElement('div') as HTMLDivElement;
  likeBlock.id = "like-block";
  likeBlock.textContent = likesArray[i] + " 👍";
  variantBlock.appendChild(likeBlock);

  let root = (document.getElementById("root") as HTMLInputElement);
  let mid = document.getElementById("mid-id") as HTMLDivElement;

  //console.log("unu");
  //db.collection("questions").doc(code).get().then(function(doc){
    //console.log(doc.data());
  //})

  //add function to each variant
  variantBlock.onclick = function() {
    let slider = document.createElement('input') as HTMLInputElement;
    slider.id = "slider";
    slider.type = "slider";
    let prompt = document.createElement('div') as HTMLDivElement;
    prompt.id = 'prompt';
    prompt.textContent = "Like 🡪 " + variantArray[i] + " ?";
    
    mid.style.display = "none";
    
    let btnNo = document.createElement('button');
    btnNo.textContent = "No";
    btnNo.id = "btnNo";

    let btnYes = document.createElement('button');
    btnYes.textContent = "Yes";
    btnYes.id = "btnNo";

    //voted
    btnYes.onclick = function() {
     // console.log("VOTED 2");
      mid.style.display = "flex";
      document.getElementById('prompt')!.remove();
      likesArray[i]++;
      variantBlock.textContent = variantArray[i] + " voted by you.";


      variantBlock.style.backgroundColor = "blue";

    
      db.collection("questions").doc(code)
      .get()
      .then(function(doc) {
        if (doc.exists) {
          //console.log("ARR: " + variantArray);
          db.collection("questions").doc(code).update({
            question: auxQuestion,
            variants:{variant: variantArray, likes: likesArray}
          })
        } else {
          // doc.data() will be undefined in this case
          //console.log("No such document!");
        }
        }).catch(function(error) {
            //console.log("Error getting document:", error);
      });

     //UPDATING
        document.getElementById("mid-id")?.remove();
        document.getElementById("header")?.remove();
        document.getElementById("spacer")?.remove();
        document.getElementById("the-footer-btn")!.remove();
        document.getElementById("the-footer-id")!.remove();
        document.getElementById("time-id")!.remove();

     window.setTimeout(function () {
       computePage(code);
     }, 500);

    }

    btnNo.onclick = function() {
      mid.style.display = "flex";
      document.getElementById('prompt')!.remove();
    }
    prompt.appendChild(btnYes);
    prompt.appendChild(btnNo);
    root.appendChild(prompt);
  }
  
  mid.appendChild(variantBlock);
  root.appendChild(mid);
}

const handleKeyDown = (event: { key: string; }) => {
  if (event.key === 'Enter') {
    //console.log("apasat");
    addVariant();
    (document.getElementById("newVariant") as HTMLInputElement).value = "";
  }
}

function updateTotalNumber() {
  let total = 0;

  db.collection("total").doc("total-number")
.get()
.then(function(doc) {
  if (doc.exists) {
      total = doc.data()!.nr;
      total++;
      //console.log(doc.data()!.nr);
      //console.log(total);

      db.collection("total").doc("total-number").update({
          nr: total
      })

  } else {
    // doc.data() will be undefined in this case
    //console.log("No such document!");
  }
  }).catch(function(error) {
     // console.log("Error getting document:", error);
  });

}

function Vote() {
    return (
      <div id="main">
        <div id="titlee" onClick={() => {
          window.location.href = '';
        }}>variantpoll</div>
        <div id="brick">
          <h1 id="motto">Making every<br></br>idea count.</h1>
          <div id="stats">
          Thank you for making me feel things I thought I could never feel. ☀️ 
          </div>
          <div id="thing">
            <input type="text" onClick={paste} id="paste-input" onKeyDown={handleKeyDownCODE} autoComplete="on" placeholder="Paste Code"></input>
          </div>
          <div id="make-poll">
            <nav>
              <Link className='btn' id='make-btn' to="/create">or Create New Poll</Link>
            </nav>
          </div>
          <button id="credits" onClick={() => window.open("https://www.linkedin.com/in/cristian-canceal-005585223/", '_blank')!.focus()} ><u>Credits</u></button>
        </div>
        
      </div>
      
    );
}

export default Vote;